import { DEFAULT_MY_LOCATION_KEYWORD } from '@/hooks/search/useSearch.constants';
import { getCookie, server } from '../helpers';

export const autocompleteService = {
  getSuggestions,
  getLocationSuggestions,
  deleteLocationSuggestion,
};

function getSuggestions(query: string, isSistaminutenSearch: boolean, signal?: AbortSignal) {
  query = (query || '').split('%25').join('%').split('%').join('%25');
  return server.request
    .get('/search/suggestions?q=' + encodeURIComponent(query) + (isSistaminutenSearch ? '&sistaminuten=1' : ''), {
      signal,
    })
    .then(server.handleSuccess)
    .catch(server.handleError);
}

function getLocationSuggestions(query: string, signal?: AbortSignal, locationSource?: string) {
  query = query.split('%25').join('%').split('%').join('%25');
  const locationData = getCookie('locationData');
  let requestUrl = `/autocomplete/location?q=${query}`;
  if (locationSource === 'v2') {
    requestUrl += `&locationSource=v2`;
  }

  if (locationData && locationData.location && locationData.location === DEFAULT_MY_LOCATION_KEYWORD) {
    const [lat, lon] = locationData.position.split('-');
    if (lat && lon) {
      requestUrl += `&lat=${lat}&lon=${lon}`;
    }
  }

  return server.request.get(requestUrl, { signal }).then(server.handleSuccess).catch(server.handleError);
}

function deleteLocationSuggestion(location: string) {
  const requestPayload = {
    location: location,
  };
  return server.request
    .post('/autocomplete/location/remove', requestPayload)
    .then(server.handleSuccess)
    .catch(server.handleError);
}
